import { render, staticRenderFns } from "./GlossSearch.vue?vue&type=template&id=239c765a&scoped=true"
import script from "./GlossSearch.vue?vue&type=script&lang=ts"
export * from "./GlossSearch.vue?vue&type=script&lang=ts"
import style0 from "./GlossSearch.vue?vue&type=style&index=0&id=239c765a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "239c765a",
  null
  
)

export default component.exports